import { css } from 'styled-components'

export const getProp = <P>(key: keyof P, preset?: P[keyof P]) => (props: P) =>
  props[key] ?? preset

export const isProp = <P>(key: keyof P) => (props: P) =>
  props[key] ? '&' : 'a-tag-will-never-be-matched'

export const onMobile = `@media screen and (max-width: 767px)`

export const onTablet = `@media screen and (min-width: 768px)`

export const title1 = css`
  font-size: 20px;
  line-height: 34px;

  ${onMobile} {
    font-size: 18px;
    line-height: 25px;
  }
`
export const body = css`
  font-size: 18px;
  line-height: 25px;

  ${onMobile} {
    font-size: 14px;
    line-height: 20px;
  }
`

export const subbody = css`
  font-size: 14px;
  line-height: 24px;

  ${onMobile} {
    font-size: 12px;
    line-height: 24px;
  }
`

export const touchable = css`
  cursor: pointer;

  &:hover {
    opacity: 0.75;
  }

  &:active {
    opacity: 0.5;
  }
`
